/* eslint-disable */ 
const count = jQuery('.DonatePartner .wp-block-column').length;
if( count < 3 ) {
  jQuery('.DonatePartner .Btn').removeClass('Btn-pink');
}